<script lang="ts">
	import { replaceContext } from "../../includes/Helpers";
	import { getContext } from "svelte";
	import Data from "./Data";
	import { z } from "zod";
	import DomainView from "../../DomainView.svelte";

	export let data: z.infer<typeof Data> = {};
	export let id: string;
	export let globalId: string;
	export let globalSource: number;
	// ignore no use
	id || globalId || globalSource;

	const context: any = getContext("context");

	let html = "";

	function setHtml(context: any) {
		if (context.client && context.client.is_mobile) {
			if (data.for_mobile) {
				html = replaceContext(data.html_mobile || "", context);
			}
		} else {
			if (data.for_desktop) {
				html = replaceContext(data.html_desktop || "", context);
			}
		}
	}

	$: setHtml($context);
</script>

{#if __ADMIN__}
	<div class="container">AdPosition &nbsp; <i class="gg-arrange-back" /></div>
{:else if data && !$context.query._reperio_admin_preview}
	<DomainView
		category="blocks"
		type="AdPosition"
		{data}
		layout="default"
		{id}
	>
		{@html html}
	</DomainView>
{/if}

<style lang="scss">
	.container {
		padding: 20px;
		background: #ccc;
		border: 1px solid #ddd;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
